import { accountAPIs } from './account';
import { commonAPIs } from './common';
import { healthKycAPIs } from './health/kyc';
import { healthPortingAPIs } from './health/porting';
import { healthProposalAPIs } from './health/proposal';
import { healthQuoteAPIs } from './health/quote';
import { healthStatusAPIs } from './health/status';
import { termOpsAPIs } from './term/ops';
import { termProposalAPIs } from './term/proposal';
import { termQuoteAPIs } from './term/quote';

const insureAPIs = {
  ...commonAPIs,
  ...termQuoteAPIs,
  ...termOpsAPIs,
  ...healthStatusAPIs,
  ...healthQuoteAPIs,
  ...healthPortingAPIs,
  ...termProposalAPIs,
  ...accountAPIs,
  ...healthProposalAPIs,
  ...healthStatusAPIs,
  ...healthKycAPIs
};

export default insureAPIs;

export * from './term/types';
export * from './term/transforms';
export * from './health/types';
export * from './health/transforms';
export * from './account/types';
